import { PlayerScores } from './../models/player-scores';
import { Pipe, PipeTransform } from '@angular/core';
import { Players } from '../models/players';

@Pipe({
  name: 'dupeName'
})
export class DupeNamePipe implements PipeTransform {

  transform(value: any, players: any, index: any): any {
    const randomNames = ['Happy Gilmore', 'Bagger Vance', 'Ty Webb', 'Carl Spackler', 'Shooter McGavin', 'Chubbs Peterson', 'Al Czervik'];
    let amount = 0;
    players.forEach((p) => {
      if (value === p.name) {
        amount++;
      }
    });
    if (amount > 1) {
      value = randomNames[Math.floor(Math.random() * randomNames.length)];
      index.name = value;
      return value;
    }
    return value;
  }

}
// check if count is greater > 1, or skip index where im editing
